import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  NavBar,
  ContextColorProvider,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';
import { PerformanceHeader } from './components/PerformanceHeader';
import { PerformanceTable } from './components/PerformanceTable';

import {
  getPortfolioPerformance,
  PortfolioPerformanceFilters,
  PortfolioPerformanceResponse
} from '@/modules/wealth/services/portfolio';
import { PerformanceFetchingStatus } from './types';


export default /*#__PURE__*/_defineComponent({
  __name: 'WealthPerformanceV2',
  setup(__props) {

let abortSignal: AbortController | null = null;

const performanceData = ref<PortfolioPerformanceResponse | null>(null);
const selectedYear = ref<string | number | null>(null);
const status = ref<PerformanceFetchingStatus>(
  PerformanceFetchingStatus.Default
);

const route = useRoute();
const router = useRouter();

const portfolioId = computed(() => {
  const { portfolioId } = route.params;
  return portfolioId;
});

const shouldRenderGlobalErrorState = computed(() => {
  return (
    status.value === PerformanceFetchingStatus.Error && !performanceData.value
  );
});

const handleGoBackClick = () => {
  router.replace({
    name: 'wealthIndexPortfolio',
    params: { portfolioId: portfolioId.value }
  });
};

const getPerformanceData = async () => {
  try {
    if (abortSignal) abortSignal.abort();
    abortSignal = new AbortController();

    status.value = PerformanceFetchingStatus.Loading;

    const params = {
      portfolioId: portfolioId.value,
      year: selectedYear.value
    };

    const data = await getPortfolioPerformance(params, abortSignal.signal);

    performanceData.value = data;
    setSelectedYear(data.filters);

    status.value = PerformanceFetchingStatus.Default;
  } catch {
    status.value = PerformanceFetchingStatus.Error;
  }
};

const setSelectedYear = (filters: PortfolioPerformanceFilters) => {
  const selectedYearOption = filters.years.find(option => option.active);
  selectedYear.value = selectedYearOption?.value || null;
};

const handleChangeYear = async (value: string | number) => {
  selectedYear.value = value;
  await getPerformanceData();
};

onMounted(async () => {
  await getPerformanceData();
});

return { __sfc: true,abortSignal, performanceData, selectedYear, status, route, router, portfolioId, shouldRenderGlobalErrorState, handleGoBackClick, getPerformanceData, setSelectedYear, handleChangeYear, NavBar, ContextColorProvider, HelperViewStatus, BackButton, ShowMoneyToggleButton, PerformanceHeader, PerformanceTable }
}

})